import { StringId } from '../localizer/stringId'

export const strings = {
  [StringId.AVOD_DP_season_selector]: 'Season {seasonNumber}',
}